import { useEffect, useState } from "react";
import { getNodes, getNodeSets } from "../api/quontxApi";
import SidePanel from "../components/SidePanel";
import { getPaginatedData } from "../utils";
import TopRelatedFilter from "../components/TopRelatedFilter";

const GraphAnalysisPage = () => {
  const [collapsed, setCollapsed] = useState(true);
  const [displayData, setDisplayData] = useState();
  const [isLoading, setIsLoading] = useState(false);

  const [nodes, setNodes] = useState([]);
  const [nodeSets, setNodeSets] = useState([]);

  const loadNodes = async () => {
    const nodes = await getPaginatedData(getNodes, {
      itemsPerPage: 100,
      type: "NAMED_ENTITY",
    });

    setNodes(
      nodes.data.sort((a, b) => {
        if (a.name > b.name) return 1;
        if (a.name < b.name) return -1;
        return 0;
      })
    );
  };

  const loadNodeSets = async () => {
    const nodeSets = await getPaginatedData(getNodeSets, {
      itemsPerPage: 100,
    });

    setNodeSets(
      nodeSets.data.sort((a, b) => {
        if (a.description > b.description) return 1;
        if (a.description < b.description) return -1;
        return 0;
      })
    );
  };

  useEffect(() => {
    (async () => {
      setIsLoading(true);
      await loadNodes();
      await loadNodeSets();
      setIsLoading(false);
    })();
  }, []);

  return (
    <div className="flex relative">
      <SidePanel
        collapseCallback={() => setCollapsed(!collapsed)}
        collapsed={collapsed}
        data={displayData}
      />
      <div className="grow">
        <div className="p-6 pb-0">
          <h1 className="mb-6 text-center">Data Visualisation</h1>
          <div className="w-full flex flex-col items-center content-center overflow-y-auto custom-scrollbar h-[83vh]">
            {nodeSets && nodes && (
              <TopRelatedFilter
                propagnateData={(value) => setDisplayData(value)}
                nodes={nodes}
                nodeSets={nodeSets}
                isLoading={isLoading}
              />
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default GraphAnalysisPage;
